<template>
    <h2 class="section-heading"><slot></slot></h2>
</template>

<script>
export default {
    name: "SectionHeading",
};
</script>

<style>
.section-heading {
    color: #202020;
    line-height: 0.8;
    font-size: 2rem;
    font-weight: 500;
    line-height: 1;
}

.section-heading a {
    color: hsl(220, 42%, 42%);
    transition: 0.2s;

    &:hover {
        color: hsl(220, 37%, 50%);
    }
}
</style>
